const FAMILY_MANAGEMENT_EXPERIENCE_TYPES = {
  CREATE: '[familyManagementExperience] createFamily',
  SET_CREATED: '[familyManagementExperience] setCreated',
  EDIT: '[familyManagementExperience] editFamily',
  UPDATE_ATTRIBUTE_ENABLED: '[familyManagementExperience] updateFamilyAttributeEnabled'
}

export default FAMILY_MANAGEMENT_EXPERIENCE_TYPES
